export class TimeRemaining {
    daysToDday: number;
    hoursToDday: number;
    minutesToDday: number;
    secondsToDday: number;

    constructor() {}
}
